import { render } from "./Profile.vue?vue&type=template&id=291164c3&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=291164c3&scoped=true&lang=css"

import exportComponent from "/home/helder/SDD_2/Projetos/goldylocks-central-ui-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-291164c3"]])

export default __exports__